import { PageLayout } from "api/model/dashboard/DashboardReportOptions";
import { T } from "services/lang/LanguageService";
import React from "react";
import { Leaves, setObjAttribute } from "utils/utils";
import { Input } from "../InputCategories";

type PageLayoutKey = Leaves<PageLayout>;

export const PageLayoutSubForm = (props: {
  pageLayout: PageLayout;
  onChange: (o: PageLayout) => void;
}) => {
  const onChangePageLayout = (prop: PageLayoutKey, value: any) => {
    const newPageLayout = { ...props.pageLayout };
    setObjAttribute(newPageLayout, prop, value);
    props.onChange(newPageLayout);
  };

  return (
    <React.Fragment>
      <h5 className="mb-5">{T("word.page-layout")}</h5>
      <div className="grid">
        <span className="p-float-label col-12 md:col-6">
          <Input.List
            id="input-page-layout-size"
            label={T("label.page-format-size")}
            property={"format.pageSize"}
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
            options={[
              { label: "A2", value: "A2" },
              { label: "A3", value: "A3" },
              { label: "A4", value: "A4" },
            ]}
            editable={true}
          />
        </span>

        <span className="p-float-label col-12 md:col-6">
          <Input.List
            options={[
              { label: "PORTRAIT", value: "PORTRAIT" },
              { label: "LANDSCAPE", value: "LANDSCAPE" },
            ]}
            id={"input-page-layout-orientation"}
            label={T("label.page-orentation")}
            property={"format.orientation"}
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>
      </div>

      <h5 className="mb-5">{T("label.margin-boxes")}</h5>
      <div className="grid">
        <span className="p-float-label col-12 md:col-3">
          <Input.Text
            id="input-page-layout-margin-boxes-top"
            label={T("word.top")}
            property={"margins.top"}
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>

        <span className="p-float-label col-12 md:col-3">
          <Input.Text
            id="input-page-layout-margin-boxes-bottom"
            label={T("word.bottom")}
            property={"margins.bottom"}
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>

        <span className="p-float-label col-12 md:col-3">
          <Input.Text
            id="input-page-layout-margin-boxes-left"
            label={T("word.left")}
            property={"margins.left"}
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>

        <span className="p-float-label col-12 md:col-3">
          <Input.Text
            id="input-page-layout-margin-boxes-right"
            label={T("word.right")}
            property={"margins.right"}
            sourceObj={props.pageLayout}
            onChange={onChangePageLayout}
          />
        </span>
      </div>
    </React.Fragment>
  );
};
